export { startSchema } from "./startSchema";
export { livingSituationSchema } from "./livingSituationSchema";
export { bankStatementSchema } from "./bankStatementSchema";